/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import {
  accessAPI,
  Boton,
  Titulo,
  Formulario,
  Sidebar,
  TablaFiltrable
} from "../../../../shared";

import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";

export default function TarjetaAsignarNorma({
  normas: normasProp,
  certificadoTipoId
}) {
  const [normas, setNormas] = useState(normasProp);
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [loaderAgregar, setLoaderAgregar] = useState(false);
  const toast = useRef(null);

  function agregarNorma(datosFormulario) {
    setLoaderAgregar(true);
    accessAPI(
      "PUT",
      `admin/config/certificadotipo/${certificadoTipoId}/norma`,
      datosFormulario,
      (respuesta) => {
        setNormas((prev) => [...prev, respuesta]);
        setSidebarVisible(false);
        setLoaderAgregar(false);
        toast.current?.show({
          severity: "success",
          summary: "Agregada",
          detail: "Norma agregada exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al agregar la norma",
          sticky: true
        });
        setLoaderAgregar(false);
      }
    );
  }

  function eliminarNorma(norma) {
    accessAPI(
      "DELETE",
      `admin/config/certificadotipo/${certificadoTipoId}/norma`,
      { normaid: norma.norma.id },
      () => {
        setNormas((prev) => prev.filter((n) => n.id !== norma.id));
        toast.current?.show({
          severity: "success",
          summary: "Eliminada",
          detail: "Norma eliminada exitosamente"
        });
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al eliminar la norma",
          sticky: true
        });
      }
    );
  }

  const agregarFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "normaid",
            tipoitemformularioid: 5,
            etiqueta: "Norma",
            opciones: "admin/norma",
            sinOpcionInicial: true,
            requerido: true
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Agregar norma", callback: agregarNorma, validar: true }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Card>
        <Titulo
          botones={
            <Boton icono negro callback={() => setSidebarVisible(true)}>
              <i className="pi pi-plus" />
            </Boton>
          }
        >
          Normas
        </Titulo>
        <TablaFiltrable conFiltros={false}
          value={normas}
          emptyMessage="No hay normas asignadas"
          nombreArchivo="normas_certificado_tipo"
        >
          <Column field="norma.numero" header="Número" />
          <Column
            body={(rowData) => (
              <Boton
                icono
                rojo
                chico
                confirmacion="¿Eliminar esta norma?"
                callback={() => eliminarNorma(rowData)}
              >
                <i className="pi pi-trash" />
              </Boton>
            )}
            style={{ width: "3rem", textAlign: "center" }}
          />
        </TablaFiltrable>
      </Card>

      <Sidebar
        visible={sidebarVisible}
        position="right"
        onHide={() => setSidebarVisible(false)}
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Agregar norma</Titulo>
        <Formulario
          config={agregarFormConfig}
          loader={loaderAgregar}
          key={normas.length}
        />
      </Sidebar>
    </>
  );
}
